/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Menu, MenuList } from '@pearsontechnology/aero-components';
import StudentSummary from './StudentSummary';

const StyledMenu = styled(Menu)`
  position: fixed;
  width: 396px;
  right: 100px;
  top: 75px;
  padding: 20px 18px 10px 18px;
  z-index: 5;
  max-height: 500px;
  overflow: auto;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.status === 'entering' || props.status === 'entered' ? 1 : 0)};
`;

const EnrolledStudentsCard = ({ list, activeStudent, constantRoute, maxScore, attemptId, ...props }) => {
  const activeStudentIndex = list.map((x) => x.id).indexOf(activeStudent.id);

  return (
    <StyledMenu {...props}>
      <MenuList>
        {list.map((activeStudent, i) => (
          <StudentSummary
            list={list}
            activeStudent={activeStudent}
            active={i === activeStudentIndex}
            constantRoute={constantRoute}
            key={`${activeStudent.id}-${i}`}
            maxScore={maxScore}
            attemptId={attemptId}
            {...props}
          />
        ))}
      </MenuList>
    </StyledMenu>
  );
};

EnrolledStudentsCard.propTypes = {
  list: PropTypes.array,
  activeStudent: PropTypes.object,
  constantRoute: PropTypes.string,
  maxScore: PropTypes.number,
  attemptId: PropTypes.string,
};

export default EnrolledStudentsCard;
